import {
  afterRenderEffect,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  input,
  signal,
  viewChild,
} from '@angular/core';
import { Skin } from '@core/interfaces/skin.interface';
import { SkinComponent } from '@core/components/skin/skin.component';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import { SvgIconComponent } from 'angular-svg-icon';
import { ModalService } from '@features/modals/services/modal.service';

@Component({
  selector: 'app-jackpot-skins-row',
  templateUrl: './jackpot-skins-row.component.html',
  styleUrls: ['./jackpot-skins-row.component.scss'],
  imports: [SkinComponent, SvgIconComponent],
})
export class JackpotSkinsRowComponent {
  readonly skins = input.required<Skin[]>();

  sliderRef = viewChild<ElementRef<HTMLElement>>('sliderRef');
  slider = signal<KeenSliderInstance | null>(null);
  currentSlide = signal(0);

  private destroyRef = inject(DestroyRef);
  private modalService = inject(ModalService);

  constructor() {
    afterRenderEffect(() => {
      const sliderRef = this.sliderRef()?.nativeElement;

      if (sliderRef) {
        this.slider.set(
          new KeenSlider(sliderRef, {
            loop: false,
            drag: true,
            slides: {
              perView: 'auto',
              spacing: 8,
            },

            slideChanged: (slider) => {
              this.currentSlide.set(slider.track.details.rel);
            },
          })
        );
      }
    });

    this.destroyRef.onDestroy(() => {
      this.slider()?.destroy();
    });
  }

  sliderMove(direction: 'prev' | 'next' | 'start' | 'end') {
    if (direction === 'prev') {
      this.slider()?.prev();
    } else if (direction === 'next') {
      this.slider()?.next();
    } else if (direction === 'start') {
      this.slider()?.moveToIdx(0);
    } else if (direction === 'end') {
      this.slider()?.moveToIdx(this.slider()?.track.details.maxIdx ?? 0);
    }
  }

  openJoinGame() {
    this.modalService.openModal('DepositJackpotModal');
  }
}
